import React, { useState } from 'react';
import NoticesInput from './Notices/Input';
import { useQuery } from '@apollo/client';
import { BIDDING_NOTICES } from './Notices/queries';
import { Button } from './elements';

import {
  Subtitle,
  NoticesContainer,
  NoticeContainer,
  NoticeText,
  NoticesSelectContainer,
} from './elements';
import colors from '../../styles/colors';

const NoticesInterface = ({ saleId, updateSale }) => {
  const [biddingNotice, setBiddingNotice] = useState('');
  const { data: noticesData, refetch: noticesRefetch } =
    useQuery(BIDDING_NOTICES);

  const saveBiddingNotice = value => {
    updateSale({
      variables: { id: saleId, biddingNotice: value }
    });
  };

  return (
    <NoticesContainer>
      <NoticesSelectContainer style={{justifyContent: 'space-between'}}>
        <Subtitle>Live Message</Subtitle>
        <Button
          title="Clear Message"
          color={colors.elRed}
          style={{maxWidth: '40%', padding: '5px'}}
          onPress={() => {
            saveBiddingNotice('');
            setBiddingNotice('');
          }}
        />
      </NoticesSelectContainer>

      <NoticeContainer
        key={biddingNotice}
        notice={biddingNotice}
      >
        <NoticeText>{biddingNotice || ' '}</NoticeText>
      </NoticeContainer>
      <NoticesInput
        notices={noticesData?.biddingNotices}
        refetch={noticesRefetch}
        handleChange={saveBiddingNotice}
        biddingNotice={biddingNotice}
        setBiddingNotice={setBiddingNotice}
      />
      {/* <Notices notices={noticesData?.biddingNotices} refetch={noticesRefetch} /> */}
    </NoticesContainer>
  )
}

export default NoticesInterface;